module.exports = __webpack_public_path__ + "img/util-tab-5-title.9aa69ec3.svg";